export default __webpack_public_path__ + "static/media/IkonSamfundsansvar.c0ceb891.svg";